import { GET_CONTENT_ERR, GET_CONTENT_REQ, GET_CONTENT_RES } from '../constants';
import { handleAsync } from './reducerUtils';

const initState = {
  content: [],
  content_loaded: false,
  errors: [],
};

const reducer = (state = initState, action) => {
  const next = handleAsync(state, action, { req: GET_CONTENT_REQ, res: GET_CONTENT_RES, err: GET_CONTENT_ERR, dataKey: 'content' });
  if (next) return next;

  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
